import React from "react";
import { useNavigate, useParams } from "react-router";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import ViewSidebarOutlinedIcon from "@mui/icons-material/ViewSidebarOutlined";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";

import { usePermissions } from "../../contexts/permissions";
import { useProjectInventory } from "../../contexts/projectInventory";
import { useProject } from "../../contexts/project";
import useQueryParamModal from "../../hooks/useQueryParamModal";
import GroupedAssetViewModal from "../asset/grouped-asset/GroupedAssetViewModal";
import {
  GROUP_VIEW_PARAM,
  GROUP_VIEW_FILTER_PARAMS,
} from "../asset/grouped-asset/groupViewParams";

export { GROUP_VIEW_PARAM };

const GROUP_VIEW_CLEAR_PARAMS = Object.values(GROUP_VIEW_FILTER_PARAMS);

export default function Views() {
  const { can } = usePermissions();
  const navigate = useNavigate();
  const params = useParams();
  const currentTab = params.tab;
  const { clientId, inputProjectId: projectId } = useProjectInventory();
  const currentProject = useProject();
  const {
    isOpen: isGroupedViewModalOpen,
    open: openGroupedViewModal,
    close: closeGroupedViewModal,
  } = useQueryParamModal(GROUP_VIEW_PARAM, { clearParams: GROUP_VIEW_CLEAR_PARAMS });
  const displayGroupView =
    projectId && (currentProject?.importedAssets || currentProject?.referenceAssets);

  const TABS = [
    {
      value: "assets",
      label: "Table View",
      disabled: !can("pages.dashboard"),
    },
    {
      value: "capture-inventory",
      label: "Split View",
      disabled: !can("features.capture_inventory"),
    },
  ];

  const availableTabs = TABS.filter(tab => !tab.disabled);

  const onChangeTab = tab => {
    if (projectId && projectId !== "all") {
      navigate(`/projects/${projectId}/${tab}`);
    } else if (clientId) {
      navigate(`/clients/${clientId}/${tab}`);
    }
  };

  return (
    <>
      <PopupState variant="popover" popupId="demo-popup-menu">
        {popupState => (
          <React.Fragment>
            <MenuItem {...bindTrigger(popupState)}>
              <ViewSidebarOutlinedIcon
                sx={{ transform: "rotate(180deg)", color: "#546e7a" }}
                fontSize="small"
              />
              <Box mr={1} />
              <Typography color="textSecondary" variant="body2">
                Views
              </Typography>
            </MenuItem>
            <Menu {...bindMenu(popupState)} sx={{ display: "flex", flexDirection: "column" }}>
              {availableTabs.map(option => (
                <MenuItem
                  key={option.value}
                  data-id="select-item"
                  selected={currentTab === option.value}
                  onClick={() => {
                    popupState.close();
                    if (["assets", "capture-inventory"].includes(option.value)) {
                      localStorage.setItem("selectedPage", option.value);
                    }
                    onChangeTab(option.value);
                  }}
                >
                  <ListItemText primary={option.label} />
                </MenuItem>
              ))}
              {displayGroupView && (
                <MenuItem
                  key="group-view"
                  data-id="select-item"
                  selected={isGroupedViewModalOpen}
                  onClick={e => {
                    e.preventDefault();
                    popupState.close();
                    openGroupedViewModal();
                  }}
                >
                  <ListItemText primary="Group View" />
                </MenuItem>
              )}
            </Menu>
          </React.Fragment>
        )}
      </PopupState>
      {isGroupedViewModalOpen && (
        <GroupedAssetViewModal
          project={currentProject}
          projectId={projectId}
          onClose={closeGroupedViewModal}
        />
      )}
    </>
  );
}
